import styled from 'styled-components';

export const StyledHeading = styled.h1<{ italic?: boolean }>`
	font-size: 1.15rem;
	font-style: ${(props) => (props.italic ? 'italic' : 'normal')};
	font-weight: bold;
	line-height: 1.5rem;

	& + * {
		margin-top: 0.5rem;
	}
`;

export const StyledSubHeading = styled.h2<{ italic?: boolean }>`
	font-size: 0.925rem;
	font-style: ${(props) => (props.italic ? 'italic' : 'normal')};
	font-weight: bold;
	line-height: 1.5rem;

	& + * {
		margin-top: 0.5rem;
	}
`;

export const StyledSmallHeading = styled.h2<{ italic?: boolean }>`
	font-size: 1.025rem;
	font-style: ${(props) => (props.italic ? 'italic' : 'normal')};
	font-weight: bold;
	line-height: 1.5rem;

	& + * {
		margin-top: 0.5rem;
	}
`;

export const StyledBodyText = styled.p`
	line-height: 1.5;

	& + * {
		margin-top: 0.5rem;
	}
`;

export const StyledOrderedList = styled.ol`
	list-style: decimal inside;

	& + * {
		margin-top: 0.5rem;
	}
`;

export const StyledDivider = styled.hr`
	background: none;
	border: 0;
	height: 0.125rem;
	position: relative;

	&::after {
		background: currentColor;
		content: '';
		display: block;
		height: 100%;
		left: 50%;
		position: absolute;
		top: 0;
		transform: translateX(-0.25rem);
		width: 0.5rem;
	}

	& + * {
		margin-top: 0.5rem;
	}
`;
